// extracted by mini-css-extract-plugin
export var Section = "Awards-module--Section--Aa4N4";
export var SectionTitle = "Awards-module--SectionTitle--mNw79";
export var Items = "Awards-module--Items--Q1npX";
export var arrowLeft = "Awards-module--arrowLeft--pqmbV";
export var arrowRight = "Awards-module--arrowRight--rirOI";